const HEADER = "N3T";

const NAVBAR_DATA = [
  { id: 1, url: "#services", label: "Services" },
  { id: 2, url: "#about-us", label: "About" },
  { id: 3, url: "#quote", label: "Contact" }
];
const BANNER_DATA = {
  HEADING: "Your Web partner",
  DECRIPTION:
    "N3T develops modern websites fast, within budget.",
};
const SERVICE_DATA = {
  HEADING: "Our Services",
  ALL_SERVICES: "All Services",
  SERVICE_LIST: [
    {
      LABEL: "Development",
      DESCRIPTION:
        "We design and develop custom web and mobile solutions.",
      URL: "images/undraw_in_progress_ql66.svg"
    },
    {
      LABEL: "E-shops",
      DESCRIPTION:
        "We create modern web shops that customers love.",
      URL: "images/undraw_shopping_app_flsj.svg"
    },
    {
      LABEL: "Performance",
      DESCRIPTION:
        "We use latest tools and aim for the highest performance and quality.",
      URL: "images/undraw_mobile_testing_reah.svg"
    }
  ]
};

const ABOUT_DATA = {
  HEADING: "",
  TITLE: "Why choose us?",
  IMAGE_URL: "images/undraw_connected_world_wuay.svg",
  WHY_CHOOSE_US_LIST: [
    "Distributed team with Projects worldwide.",
    "15+ years of experience.",
    "150+ projects completed.",
    "Cost effective solutions for any budget.",
    "We build for web and mobile.",
    "High customer statisfaction.",
    "Clear & transparent fee structure.",
    "Continuous support.",
  ]
};

const QUOTE_DATA = {
  HEADING: "Have a project in mind ?",
  TITLE: "Contact us",
  SUBTITLE: "We will be very glad to hear from you.",
  IMAGE_URL: "images/undraw_contact_us_15o2.svg",
  EMAIL: "info@n3t.gr",
  MESSENGER: "giorgos.kontopoulos",
  WHATSAPP: "306948067126"
};

const FOOTER_DATA = {
  DESCRIPTION:
    "We are a distributed team based in Greece and we always strive for the highest quality.",
  CONTACT_DETAILS: {
    HEADING: "Contact us",
    ADDRESS: "Martyron 9, Chios 82100, Greece",
    MOBILE: "📱 +30 694 8067 126",
    EMAIL: "info@n3t.gr",
    EMAIL_ICON: "✉️",
  },
  SUBSCRIBE_NEWSLETTER: "Subscribe to newsletter",
  SUBSCRIBE: "Subscribe"
};

const MOCK_DATA = {
  HEADER,
  NAVBAR_DATA,
  BANNER_DATA,
  SERVICE_DATA,
  ABOUT_DATA,
  QUOTE_DATA,
  FOOTER_DATA
};
export default MOCK_DATA;
